import React from 'react';
import type { GatsbyBrowser } from 'gatsby';
import { Script, navigate } from 'gatsby';

import { FeatureFlagConfig, FeatureFlagProvider, processFeatureFlags, Theme } from '@world-vision/wv360-core-library';
import { GATSBY_FEATURE_FLAGS, ANALYTICS_SOURCE } from 'gatsby-env-variables';

import Layout from './src/components/Layout';
import routing from './src/data/router/routing.json'
import { PageContext } from './src/types/components/props';

import './src/styles/global.scss';

const onlyBody = {
  headerClassName: "scrollHidden",
  showFooter: false,
  showHeader: false
};

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = (data) => {
  const {
    element,
    props,
  } = data;
  const pageProps = (props?.pageContext as PageContext)?.props;
  const layoutProps = pageProps?.layout?.onlyBody ? onlyBody : {};
  return (
    <Theme>
      <Layout {...layoutProps}>
        {element}
      </Layout>
    </Theme>
  );
};

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({
  element,
}) => {
  return (
    <>
      <FeatureFlagProvider config={GATSBY_FEATURE_FLAGS}>
        {element}
      </FeatureFlagProvider>
      {ANALYTICS_SOURCE && <Script src={`${ANALYTICS_SOURCE}`} async />}
    </>
  );
};

// this is used to hide features that is not ready yet and redirect users to a specific page
const routeByFeatureFlag: { [key: string]: Record<string, string> } = {
  childSponsorshipHide: {
    ChildSponsorship: '/en/sponsor-a-child.html',
  },
  singleGiftPageHide: {
    SingleGiftProduct: '/en/',
  },
  conversionPageHide: {
    'ROC/Conversion': '/en/',
  },
  awarenessPageHide: {
    'ROC/Awareness': '/en/',
  },
  employerMatchingHide: {
    EmployerMatching: '/en/',
  },
  allGiftsPageHide: {
    AllGiftsPage: '/en/',
  },
  donationProductsPageHide: {
    DonationProducts: '/en/',
  },
};

const redirectFeature = (flags: FeatureFlagConfig) => {
  let forceRedirect = false;
  let redirectURL = '';
  for (const flag in flags) {
    if (flag) {
      forceRedirect = !!routing.find(({ path, page }) => {
        const pageName = page?.[0]?.name;
        const newRoute = path && routeByFeatureFlag?.[flag]?.[path];
        if (newRoute !== undefined && window.location.href.includes(pageName)) {
          console.log('redirect feature', flag, pageName, newRoute);
          redirectURL = `${window.location.origin}${newRoute}`;
          return true;
        }
        return false;
      });

      if (forceRedirect) {
        break;
      }
    }
  }
  return { forceRedirect, redirectURL };
}

export const onClientEntry = () => {
  const flags = processFeatureFlags(GATSBY_FEATURE_FLAGS?.split(',') ?? []) ?? {};
  const { pathname, search } = window.location;
  console.log('onClientEntry pathname', pathname);
  const { forceRedirect, redirectURL } = redirectFeature(flags);
  if (forceRedirect && redirectURL) {
    window.location.replace(redirectURL);
  } else if (pathname === '/shadow-entry' && search) { // shadow-entry is used to redirect users to a gatsby specific page, but will not needed anymore and will be removed in the future
    const target = new URLSearchParams(search).get('target');
    if (target) {
      console.log('onClientEntry target', target);
      navigate(target, { replace: true });
    }
  }
};